








import { Vue, Component, Prop } from "vue-property-decorator";
import { mapState } from "vuex";

// Types
import { IState } from "@/store";
import { IBrand } from "@/models/brands";

@Component({
  components: {
    "dynamic-categories-list": () =>
      import("@/components/app/admin/settings/dynamicCategoriesList.vue")
  },
  computed: {
    ...mapState({
      brandId(state: IState) {
        return state.brand.id;
      }
    })
  }
})
export default class AdminSettingsView extends Vue {
  public $refs!: {
    search: HTMLFormElement;
  };
  public brandId!: IBrand["id"];
  // Props
  @Prop({ default: [] })
  public routes!: Function;
  // Data
  public search = "";
  // Getters
  public get filteredRoutes() {
    return this.$_.filter(
      this.$_.flatMap(this.routes(), (group, gI) =>
        this.$_.map(group.routes, route => {
          return {
            ...route,
            groupId: gI,
            isDisabled: !this.$userCan(...route.auth)
          };
        })
      ),
      route => {
        if (!this.search.length) return true;
        return (
          route.title.toLowerCase().includes(this.search.toLowerCase()) ||
          route.description.toLowerCase().includes(this.search.toLowerCase())
        );
      }
    );
  }

  public get filteredRoutesByGroup() {
    return this.$_.omitBy(
      this.$_.map(this.routes(), (group, gI) => {
        return {
          group: group.group,
          routes: this.$_.pickBy(
            this.filteredRoutes,
            route => route.groupId === gI
          )
        };
      }),
      group => this.$_.isEmpty(group.routes)
    );
  }
  // Methods
  public mounted() {
    setTimeout(() => {
      if (!this.$refs.search) {
        return;
      }
      this.$refs.search.focus();
    }, 500);
  }
  public highlight = (needle, haystack) =>
    haystack.replace(
      new RegExp(needle, "gi"),
      str => `<span class="has-text-info">${str}</span>`
    );
}
